<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- 轮播图 -->
    <el-row>
      <el-col :xs="0" :sm="1" :md="2" :lg="2" :xl="4"></el-col>
      <el-col :xs="24" :sm="22" :md="20" :lg="20" :xl="16">
        <div class="full-page-slide-wrapper">
          <swiper
            v-if="bannerArr.length > 1"
            :options="fullswiperOption"
            ref="mySwiper"
          >
            <template v-for="(item, index) in bannerArr">
              <swiper-slide :key="index">
                <img :src="$imgUrl + item.imgurl" alt />
              </swiper-slide>
            </template>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </el-col>
      <el-col :xs="0" :sm="1" :md="2" :lg="2" :xl="4"></el-col>
    </el-row>
    <el-row>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
      <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
        <div class="container">
          <!--首页模块-->
          <div class="mainwrap" v-if="wrapMode.length > 0">
            <div class="wrapMode">
              <div
                class="modeList"
                v-for="(item, index) in wrapMode"
                :key="index"
                @mouseover="mouseOver(item, index, $event)"
                @mouseleave="mouseLeave(item, index, $event)"
                :style="item.active ? item.active : ''"
                @click="toList('/' + item.tap)"
              >
                <div class="icon">
                  <img
                    :src="item.activeIcon ? item.en_icon : item.icons"
                    alt=""
                  />
                </div>
                <div class="cn_name">{{ item.name }}</div>
                <div class="en_name">{{ item.en_name }}</div>
              </div>
            </div>
          </div>
          <!-- 观众与登记和商贸 -->
          <div class="mainwrap">
            <div class="wrapModeTwo">
              <div class="modeBox bg1" v-if="langSet == 'zh'">
                <div>观众预登记</div>
                <div>中国国际家用纺织品及辅料博览会</div>
                <div @click="openNewUrl()" style="cur">立即前往</div>
              </div>
              <div class="modeBox bg1" v-if="langSet == 'en'">
                <div>Pre-registration</div>
                <div></div>
                <div @click="openNewUrl()" style="margin-top: 29px">
                  Register now
                </div>
              </div>
              <div class="modeBox bg2" v-if="langSet == 'zh'">
                <div>商贸配对</div>
                <div>服务主旨是为您提供新的商机</div>
                <div @click="toList('/pair')">立即查看</div>
              </div>
              <div class="modeBox bg2" v-if="langSet == 'en'">
                <div>Online Business Matching</div>
                <div></div>
                <div @click="toList('/pair')" style="margin-top: 29px">
                  Read more
                </div>
              </div>
            </div>
          </div>
          <!-- 广告位 -->
          <a :href="adUrl"><img :src="$imgUrl + ad" alt="" class="adimg" /></a>
          <!-- 展商推荐 -->
          <div class="mainwrap" v-if="companyList.length > 0">
            <el-row
              class="main-top"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <el-col
                v-if="langSet == 'zh' || homeConfig.en_filed_1.length == 0"
                :span="18"
                class="title"
                >{{ homeConfig.filed_1 }}</el-col
              >
              <el-col
                v-if="langSet == 'en' && homeConfig.en_filed_1.length > 0"
                :span="18"
                class="title"
                >{{ homeConfig.en_filed_1 }}</el-col
              >
              <el-col
                :span="3"
                class="more"
                @click.native="toList('/exhibitor')"
                >{{ $t("home.more") }}</el-col
              >
            </el-row>
            <Swiper :options="swiperOption" class="company swiper-container">
              <SwiperSlide
                class="swiper-wrapper com-list"
                v-for="item in companyList"
                :key="item.id"
                @click.native="toDetail('exhibitorDetail', item.id)"
              >
                <img :src="$imgUrl + item.thumb" alt="" />
                <div
                  v-if="langSet == 'zh' || item.enCompanyName.length == 0"
                  class="com-text"
                >
                  {{ item.companyName }}
                </div>
                <div
                  v-if="langSet == 'en' && item.enCompanyName.length > 0"
                  class="com-text"
                >
                  {{ item.enCompanyName }}
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <!-- 精品展示 -->
          <!-- <div class="mainwrap" v-if="productList.length > 0">
              <el-row class="main-top" type="flex" justify="space-between" align="middle">
                <el-col v-if="langSet == 'zh' || homeConfig.en_filed_2.length == 0 " :span="18" class="title">{{homeConfig.filed_2}}</el-col>
                <el-col v-if="langSet == 'en' && homeConfig.en_filed_2.length > 0" :span="18" class="title">{{homeConfig.en_filed_2}}</el-col>
                <el-col :span="3" class="more" @click.native="toList('/product')">{{$t('home.more')}}</el-col>
              </el-row>
              <Swiper :options="proSwiperOption"  class="hproduct-swiper-container swiper-container">
                <SwiperSlide class="swiper-wrapper" v-for="(item, index) in productList" :key="index" @click.native="toDetail('prodetail', item.id)">
                  <img :src="$imgUrl + item.img" alt=""> 
                  <div v-if="langSet == 'zh' || item.en_goodsName.length == 0 " class="com-text">{{item.goodsName}}</div>
                  <div v-if="langSet == 'en' && item.en_goodsName.length > 0" class="com-text">{{item.en_goodsName}}</div>
                  <div v-if="langSet == 'zh' &&  item.characteristic.length > 0 || item.en_characteristic.length == 0" class="com-char">{{item.characteristic}}</div>
                  <div v-if="langSet == 'en' && item.en_characteristic.length > 0" class="com-char">{{item.en_characteristic}}</div>
                </SwiperSlide>
              </Swiper>
            </div> -->
          <!-- 嘉宾寄语 -->
          <div class="mainwrap" v-if="famousList.length > 0">
            <el-row
              class="main-top"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <el-col
                v-if="langSet == 'zh' || homeConfig.en_filed_5.length == 0"
                :span="18"
                class="title"
                >{{ homeConfig.filed_5 }}</el-col
              >
              <el-col
                v-if="langSet == 'en' && homeConfig.en_filed_5.length > 0"
                :span="18"
                class="title"
                >{{ homeConfig.en_filed_5 }}</el-col
              >
              <el-col
                :span="3"
                class="more"
                @click.native="toList('/guestmessage')"
                >{{ $t("home.more") }}</el-col
              >
            </el-row>
            <el-row class="name">
              <el-col
                class="name-list"
                :span="8"
                v-for="item in famousList"
                :key="item.id"
              >
                <img :src="$imgUrl + item.avatar" alt="" />
                <div
                  v-if="langSet == 'zh' || item.en_first_characters.length == 0"
                  class="first"
                >
                  {{ item.first_characters }}
                </div>
                <div
                  v-if="langSet == 'en' && item.en_first_characters.length > 0"
                  class="first"
                >
                  {{ item.en_first_characters }}
                </div>
                <div
                  v-if="
                    langSet == 'zh' || item.en_second_characters.length == 0
                  "
                  class="second"
                >
                  {{ item.second_characters }}
                </div>
                <div
                  v-if="langSet == 'en' && item.en_second_characters.length > 0"
                  class="second"
                >
                  {{ item.en_second_characters }}
                </div>
                <div
                  v-if="langSet == 'zh' || item.en_third_characters.length == 0"
                  class="third"
                >
                  {{ item.third_characters }}
                </div>
                <div
                  v-if="langSet == 'en' && item.en_third_characters.length > 0"
                  class="third"
                >
                  {{ item.en_third_characters }}
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 精彩活动 -->
          <div class="mainwrap" v-if="activitylist.length > 0">
            <el-row
              class="main-top"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <el-col
                v-if="langSet == 'zh' || homeConfig.en_filed_3.length == 0"
                :span="18"
                class="title"
                >{{ homeConfig.filed_3 }}</el-col
              >
              <el-col
                v-if="langSet == 'en' && homeConfig.en_filed_3.length > 0"
                :span="18"
                class="title"
                >{{ homeConfig.en_filed_3 }}</el-col
              >
              <el-col
                :span="3"
                class="more"
                @click.native="toList('/active')"
                >{{ $t("home.more") }}</el-col
              >
            </el-row>
            <Swiper
              :options="swiperOption"
              class="active-swiper-container swiper-container"
            >
              <SwiperSlide
                class="swiper-wrapper"
                v-for="(item, index) in activitylist"
                :key="index"
                @click.native="toDetail('activelist', item.id)"
              >
                <img :src="$imgUrl + item.thumb" alt="" />
              </SwiperSlide>
            </Swiper>
          </div>
          <!-- 新闻资讯 -->
          <div class="mainwrap" v-if="langSet == 'zh'">
            <el-row
              class="main-top"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <el-col :span="18" class="title">{{ homeConfig.filed_4 }}</el-col>
              <el-col :span="3" class="more" @click.native="toList('/news')">{{
                $t("home.more")
              }}</el-col>
            </el-row>
            <el-row
              class="news"
              v-for="item in cn_newsList"
              :key="item.id"
              @click.native="toNewsDetail(item, 'cn')"
            >
              <el-col>
                <div v-if="item.style == 4">
                  <div class="news-one" style="cursor: pointer">
                    <div class="home_newsBox">
                      <div class="home_newsBox_text">
                        <div
                          v-if="langSet == 'zh' || item.en_title.length == 0"
                          class="home_newsBox_main"
                        >
                          {{ item.title }}
                        </div>
                        <div
                          v-if="langSet == 'en' && item.en_title.length > 0"
                          class="home_newsBox_main"
                        >
                          {{ item.en_title }}
                        </div>
                        <div
                          v-if="
                            langSet == 'zh' || item.en_inputtime.length == 0
                          "
                          class="sub"
                        >
                          {{ item.inputtime }}
                        </div>
                        <div
                          v-if="langSet == 'en' && item.en_inputtime.length > 0"
                          class="sub"
                        >
                          {{ item.en_inputtime }}
                        </div>
                      </div>
                      <div class="home_newsBox_img">
                        <img :src="$imgUrl + item.url" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else style="cursor: pointer">
                  <div
                    v-if="langSet == 'zh' || item.en_title.length == 0"
                    class="news-title"
                  >
                    {{ item.title }}
                  </div>
                  <div
                    v-if="langSet == 'en' && item.en_title.length > 0"
                    class="news-title"
                  >
                    {{ item.en_title }}
                  </div>
                  <div
                    class="imglist"
                    v-for="(_item, _index) in item.thumb"
                    :key="_index"
                  >
                    <img
                      :class="[item.style == 3 ? 'imgmore' : 'imgone']"
                      :src="$imgUrl + _item.url"
                    />
                  </div>
                  <div class="sub">
                    <div
                      v-if="langSet == 'zh' || item.en_inputtime.length == 0"
                    >
                      {{ item.inputtime }}
                    </div>
                    <div v-if="langSet == 'en' && item.en_inputtime.length > 0">
                      {{ item.en_inputtime }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="mainwrap" v-if="langSet == 'en'">
            <!-- <el-row class="main-top" type="flex" justify="space-between" align="middle" >
               
                <el-col v-if="homeConfig.en_filed_4.length > 0" :span="18" class="title">{{homeConfig.en_filed_4}}</el-col>
                <el-col :span="3" class="more" @click.native="toList('/news')">{{$t('home.more')}}</el-col>
              </el-row> -->
            <el-row
              class="news"
              v-for="item in en_newList"
              :key="item.id"
              @click.native="toNewsDetail(item, 'en')"
            >
              <el-col>
                <div v-if="item.style == 4">
                  <div class="news-one" style="cursor: pointer">
                    <div class="home_newsBox">
                      <div class="home_newsBox_text">
                        <div
                          v-if="langSet == 'zh' || item.en_title.length == 0"
                          class="home_newsBox_main"
                        >
                          {{ item.title }}
                        </div>
                        <div
                          v-if="langSet == 'en' && item.en_title.length > 0"
                          class="home_newsBox_main"
                        >
                          {{ item.en_title }}
                        </div>
                        <div
                          v-if="
                            langSet == 'zh' || item.en_inputtime.length == 0
                          "
                          class="sub"
                        >
                          {{ item.inputtime }}
                        </div>
                        <div
                          v-if="langSet == 'en' && item.en_inputtime.length > 0"
                          class="sub"
                        >
                          {{ item.en_inputtime }}
                        </div>
                      </div>
                      <div class="home_newsBox_img">
                        <img :src="$imgUrl + item.url" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else style="cursor: pointer">
                  <div
                    v-if="langSet == 'zh' || item.en_title.length == 0"
                    class="news-title"
                  >
                    {{ item.title }}
                  </div>
                  <div
                    v-if="langSet == 'en' && item.en_title.length > 0"
                    class="news-title"
                  >
                    {{ item.en_title }}
                  </div>
                  <div
                    class="imglist"
                    v-for="(_item, _index) in item.thumb"
                    :key="_index"
                  >
                    <img
                      :class="[item.style == 3 ? 'imgmore' : 'imgone']"
                      :src="$imgUrl + _item.url"
                    />
                  </div>
                  <div class="sub">
                    <div
                      v-if="langSet == 'zh' || item.en_inputtime.length == 0"
                    >
                      {{ item.inputtime }}
                    </div>
                    <div v-if="langSet == 'en' && item.en_inputtime.length > 0">
                      {{ item.en_inputtime }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
    </el-row>
    <el-backtop>{{ $t("home.top") }}</el-backtop>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import {
  getBanner,
  getCompanylist,
  getProductlist,
  getFamouslist,
  getActivitylist,
  getNewslist,
  getConfig,
} from "@/api/api";
export default {
  components: { top, bottom, Swiper, SwiperSlide },
  name: "home",
  data() {
    return {
      active: "",
      items: [],
      defaultIndex: 0,
      fullswiperOption: {
        direction: "horizontal",
        loop: true,
        autoplay: 5000,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
      },
      bannerArr: [],
      inforList: [],
      ad: "",
      adUrl: "",
      companyList: [],
      productList: [],
      famousList: [],
      activitylist: [],
      wrapMode: [
        {
          icons: require("../../assets/show.png"),
          en_icon: require("../../assets/en_show.png"),
          name: "展会信息",
          en_name: "Show Information",
          active: "",
          fontCol: "",
          activeIcon: "",
          tap: "conference",
        },
        {
          icons: require("../../assets/search.png"),
          en_icon: require("../../assets/en_search.png"),
          name: "展商搜索",
          en_name: "Exhibitor Search",
          active: "",
          fontCol: "",
          activeIcon: "",
          tap: "exhibition",
        },
        {
          icons: require("../../assets/huodong.png"),
          en_icon: require("../../assets/en_hudong.png"),
          name: "精彩活动",
          en_name: "Fringe Programme",
          active: "",
          fontCol: "",
          activeIcon: "",
          tap: "active",
        },
        {
          icons: require("../../assets/new.png"),
          en_icon: require("../../assets/en_news.png"),
          name: "新闻中心",
          en_name: "News",
          active: "",
          fontCol: "",
          activeIcon: "",
          tap: "news",
        },
      ],
      newsList: [],
      cn_newsList: [],
      en_newList: [],
      proSwiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      height: "",
      mySwiper: null,
      langSet: "",
      homeConfig: {
        filed_1: "",
        filed_2: "",
        filed_3: "",
        filed_4: "",
        filed_5: "",
        en_filed_1: "",
        en_filed_2: "",
        en_filed_3: "",
        en_filed_4: "",
        en_filed_5: "",
      },
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    //console.log(this.langSet)
    this.getImglist(1);
    this.getImglist(2);
    this.getClist();
    this.getPlist();
    this.getFlist();
    this.getAlist();
    this.getNlist();
    this.setHeight();
    this.getConfig();
  },
  methods: {
    openNewUrl() {
      if (this.langSet == "zh") {
        // 25.12.19 更新链接 dxm
        window.open(
          "https://ezt3.eastfair.com/dingzhi/h5-registration-jiafang/#/jump?exhibitionId=2018497552125587458&registerType=visitor&languageType=cn&registrationSource=registration&tenantId=762803&registerLinkId=2018508282224766977&isOpenAdapt=no&sourceCode=2608-1034",
          "_blank"
        );
      } else {
        window.open(
          "https://itsh.exporeg.cn/dingzhi/pc-registration-jiafang/#/jump?exhibitionId=2018497552125587458&registerType=visitor&languageType=en&registrationSource=registration&tenantId=762803&registerLinkId=2018507836299288577&isOpenAdapt=yes&sourceCode=2608-2039",
          "_blank"
        );
      }
    },
    mouseOver: function (item, index, e) {
      var wrapMode = this.wrapMode;
      wrapMode[index].active =
        "background: linear-gradient(360deg, #CAC28A 0%, #9B8B1C 100%);color: #ffffff";
      wrapMode[index].activeIcon = "true";
      this.wrapMode = wrapMode;
    },
    mouseLeave: function (item, index, e) {
      var wrapMode = this.wrapMode;
      wrapMode[index].active = "";
      wrapMode[index].activeIcon = "";
      this.wrapMode = wrapMode;
    },

    itemClick(i) {
      this.currentIndex = i;
    },
    setHeight() {
      this.height = window.innerWidth * 0.7 + "px";
    }, //基本配置
    getConfig() {
      getConfig()
        .then((res) => {
          if (res.data.errno == 0) {
            this.homeConfig = res.data.rst;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取轮播图列表
    getImglist(cid) {
      let data = this.$qs.stringify({
        cid,
      });
      getBanner(data)
        .then((res) => {
          if (cid == 1) {
            if (res.data.rst.length > 0) {
              this.bannerArr = res.data.rst;
            }
          } else {
            if (res.data.rst.length > 0) {
              this.ad = res.data.rst[0].imgurl;
              this.adUrl = res.data.rst[0].http;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, //展商推荐
    getClist() {
      let data = this.$qs.stringify({
        pagesize: 8,
      });
      getCompanylist(data)
        .then((res) => {
          //console.log(res.data.rst)
          if (res.data.errno == 0) {
            this.companyList = res.data.rst;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //精品推荐
    getPlist() {
      let data = this.$qs.stringify({
        keywords: "",
        companyid: "",
        productClass_1: "",
        pagesize: 8,
        page: 1,
      });
      getProductlist(data)
        .then((res) => {
          //console.log(res.data)
          if (res.data.errno == 0) {
            this.productList = res.data.rst;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, //嘉宾寄语
    getFlist() {
      let data = this.$qs.stringify({
        pagesize: 3,
      });
      getFamouslist(data)
        .then((res) => {
          if (res.data.errno == 0) {
            this.famousList = res.data.rst;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, //精彩活动
    getAlist() {
      let data = this.$qs.stringify({
        pagesize: 8,
      });
      getActivitylist(data)
        .then((res) => {
          if (res.data.errno == 0) {
            this.activitylist = res.data.rst;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, //新闻资讯
    getNlist() {
      let data = this.$qs.stringify({
        pagesize: 3,
      });
      getNewslist(data)
        .then((res) => {
          if (res.data.errno == 0) {
            var cn_newlist = [];
            var en_newList = [];
            for (var i = 0; i < res.data.rst.length; i++) {
              var list = res.data.rst[i];
              // if (list.content !== "" && list.en_content == "") {
              //   cn_newlist.push(list);
              // } else if (list.content == "" && list.en_content !== "") {
              //   en_newList.push(list);
              // }
              // 2026.07.30修改，从判断内容改为判断标题 李晨
              if (list.title !== "") {
                cn_newlist.push(list);
              } else if (list.title === "" && list.en_title !== "") {
                en_newList.push(list);
              }
            }
            this.cn_newsList = cn_newlist;
            this.en_newsList = en_newList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳列表页
    toList(path) {
      console.log(path);
      this.$router.push({ path });
    },
    toDetail(name, id) {
      console.log(name, id);
      this.$router.push({ name, query: { id } });
    },
    toNewsDetail(item, lang) {
      if (item.http_type == "1") {
        this.$router.push({
          name: "newsdetails",
          query: { id: item.id },
        });
      } else if (item.http_type == "2") {
        if (lang === "cn") {
          window.open(item.http_url_cn, "_blank");
        } else {
          window.open(item.http_url_en, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.modeBox div {
  margin-left: 50px;
}
.modeBox div:nth-child(1) {
  margin-top: 30px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.modeBox div:nth-child(2) {
  margin-top: 15px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e6b77;
}
.modeBox div:nth-child(3) {
  margin-top: 15px;
  width: 95px;
  height: 30px;
  background: #cac28a;
  opacity: 0.8;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #9b8b1c;
  cursor: pointer;
}
.wrapModeTwo {
  display: flex;
  justify-content: space-around;
}
.modeBox {
  width: 412px;
  height: 150px;
}
.bg1 {
  background-image: url("../../assets/bg1.png");
  background-size: 100% 100%;
}
.bg2 {
  background-image: url("../../assets/bg2.png");
  background-size: 100% 100%;
}
// .wrapMode .modeList:nth-child(4) .icon,.wrapMode .modeList:nth-child(1) .icon{
// max-width: 40px;
// max-height: 40px;
// }
.icon {
  max-width: 32px;
  max-height: 32px;
  display: block;
  margin: 20px auto;
}
.icon:after {
  content: "";
  display: block; //块级元素
  width: 100%;
  height: 2px;

  background: #cac28a;
  opacity: 0.6;
  transform: scaleY(1); //纵向伸缩
  float: left; //
  margin-top: 18px;
}
.icon img {
  width: 100%;
  height: 100%;
}
.wrapMode {
  display: flex;
  justify-content: space-between;
}
.mainwrap .modeList {
  text-align: center;
  width: 195px;
  height: 145px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}
.cn_name {
  text-align: center;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  // color: #1A1A1A;
  margin-top: 38px;
}
.en_name {
  margin-top: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: #666666;
}
.full-page-slide-wrapper {
  width: 100%;
  margin: 0 auto;
  height: 300px;
  background: white;
  box-sizing: border-box;
  padding-top: 15px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-wrapper {
      display: flex;
      align-items: center;
    }
    .swiper-slide {
      width: calc(300px / 0.7);
      border-radius: 5px;
      opacity: 0.7;
      height: 100% !important;
      transform: scale(0.9);
    }
    .swiper-slide-active {
      opacity: 1;
      transform: scale(1);
    }
  }
  img {
    object-fit: fill;
    height: 100%;
    width: 100%;
    border-radius: 5px;
  }
  .slide_dot {
    display: inline-block;
    margin: 5px;
    width: 3px;
    height: 3px;
    background-color: #f2f2f2;
    border-radius: 50%;
    opacity: 0.5;
  }
  .swiper-pagination {
    bottom: 20px;
  }
  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: #fff;
  }
  .swiper-pagination-bullet-active {
    width: 34px;
    border-radius: 20px;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAyBAMAAAC5cHbcAAAALVBMVEUAAAA9PT3v7+/n5+d5eXkAAAAAAAAAAADh4eEAAADz8/PGxsaSkpJiYmIODg4PHZa/AAAAD3RSTlMzP8u3UgAmEKsb1oZeSTWj9cjKAAAAQklEQVQoz2NAAemhDKhgKhqfHY3PxkABYGlE5TsZokorC4xIaYauA6h8YRVUPqORw8hUoIumYB/JSY6NQHqeip4fAEVoEJ7rSjzcAAAAAElFTkSuQmCC);
    left: 0;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAyBAMAAAC5cHbcAAAAKlBMVEUAAAA9PT3v7+/n5+d5eXkAAAAAAAAAAADh4eEAAADz8/PGxsaSkpJiYmLK2R3YAAAADnRSTlMzP8u3UgAmEKsb1oZeSUaiznEAAABESURBVCjPYwgtY0ABkQyooACNn8BAKZBwQOULq6DyGY1GFYAAzwpUvpMhCpdFWWBkSF9ClWbgBkoTDxIw0jPe9I6eHwCyMxDqoi0N+AAAAABJRU5ErkJggg==);
    right: 0;
  }
  .swiper-button-prev:hover {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0 5px 5px 0;
  }
  .swiper-button-next:hover {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px 0 0 5px;
  }
  .slide_dot_active {
    display: inline-block;
    width: 7px;
    height: 3px;
    border-radius: 5px;
    background: white;
    opacity: 1;
  }
}
.adimg {
  width: 100%;
  margin-top: 53px;
  margin-bottom: 53px;
}
.el-col {
  border-radius: 0;
}
.el-carousel__container {
  height: 625px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__button {
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 100%;
}
.el-carousel__indicator.is-active button {
  width: 34px;
  border-radius: 6px;
}
.el-carousel__indicators--horizontal {
  bottom: 74px;
}
.adslot {
  border-radius: 22px;
  overflow: hidden;
  width: 100%;
  height: 275px;
  margin-top: 53px;
  img {
    width: 100%;
    height: 100%;
  }
}
.mainwrap {
  margin-top: 40px;
  .main-top {
    margin-bottom: 8px;
  }
  .title {
    font-size: 22px;
    line-height: 35px;
    font-weight: bold;
    border-left: 6px solid #cac28a;
    padding-left: 7px;
    border-radius: 0;
  }
  .more {
    width: 60px;
    height: 24px;
    min-height: 24px;
    background: #cac28a;
    border-radius: 12px !important;
    color: #fff;
    text-align: center;
    line-height: 25px;
    font-size: 13px;
    cursor: pointer;
  }
}
.company {
  .com-text {
    font-size: 17px;
    font-weight: bold;
    line-height: 35px;
    width: 100%;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    width: 100%;
    height: 150px;
    border-radius: 7px;
  }
}
.name {
  text-align: center;
  .name-list {
    line-height: 20px;
    cursor: pointer;
    img {
      width: 151px;
      height: 151px;
      border-radius: 100%;
      font-size: 18px;
    }
  }
  .first {
    font-size: 22px;
    line-height: 30px;
  }
}
.active .active-list img {
  width: 260px;
  height: 130px;
  border-radius: 7px;
}
.news {
  border-bottom: 1px dashed #777777;
  padding: 16px 0;
  .news-title {
    font-size: 22px;
    line-height: 30px;
    font-weight: bold;
  }
  .imgone {
    width: 100%;
    height: 382px;
    border-radius: 3px;
    margin-top: 8px;
  }
  .sub {
    font-size: 16px;
    line-height: 22px;
    color: #9b9b9b;
  }
}
.news:last-child {
  border-bottom: 0 none;
}
.news-one .home_newsBox {
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
}
.news-one .home_newsBox .home_newsBox_img img {
  width: 275px;
  height: 149px;
  border-radius: 3px;
}
.news-one .home_newsBox .home_newsBox_text {
  width: 486px;
  font-size: 22px;
  line-height: 30px;
  display: flex;
  flex-wrap: wrap;
}
.news-one .home_newsBox .home_newsBox_text .home_newsBox_main {
  align-self: flex-start;
  width: 100%;
  font-weight: bold;
}
.news-one .home_newsBox .home_newsBox_text .sub {
  font-size: 16px;
  line-height: 22px;
  color: #9b9b9b;
  align-self: flex-end;
  width: 100%;
}
.imglist {
  display: flex;
  justify-content: space-between;
}
.imglist .imgmore {
  width: 252px;
  height: 181px;
  border-radius: 3px;
  display: block;
}

.el-backtop {
  position: relative;
  right: 0 !important;
  bottom: 0 !important;
  margin: 90px auto 30px;
  width: 174px;
  height: 53px;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 1);
  color: #000;
  line-height: 53px;
  text-align: center;
  font-size: 18px;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  cursor: pointer;
}
.active-swiper-container {
  height: 130px;
}
.active-swiper-container .swiper-wrapper {
  width: 260px;
  height: 100%;
}
.active-swiper-container .swiper-wrapper .swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 0;
}
.company .swiper-slide {
  flex-wrap: wrap;
}
.adbanner {
  width: 100%;
  height: 200px;
}
.adbanner img {
  width: 100%;
  height: 100%;
}
.hproduct-swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      flex-wrap: wrap;
      justify-content: flex-start;
      img {
        width: 100%;
        height: 187px;
        border-radius: 3px;
      }
      .com-text {
        font-size: 18px;
        color: #000;
        line-height: 32px;
        width: 100%;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .com-char {
        font-size: 14px;
        color: #999;
        line-height: 18px;
        width: 100%;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .full-page-slide-wrapper {
    height: 6rem;
    margin: 0;
    padding: 0;
    .swiper-container {
      .swiper-slide {
        width: 100%;
        border-radius: 5px;
      }
    }
  }
  .adimg {
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .mainwrap .title {
    font-size: 15px;
    height: 0.34rem;
    min-height: 0;
    line-height: 0.34rem;
  }
  .mainwrap .more,
  .news .sub {
    font-size: 11px;
  }
  .company {
    img {
      height: 1.5rem;
    }
    .com-text {
      font-size: 14px;
    }
  }
  .mainwrap {
    margin-top: 0.4rem;
  }
  .hproduct-swiper-container {
    .swiper-wrapper {
      .swiper-slide {
        img {
          height: 1.5rem;
        }
        .com-text,
        .com-char {
          font-size: 11px;
        }
      }
    }
  }
  .active-swiper-container {
    height: 1.3rem;
  }
  .news {
    .news-title {
      font-size: 16px;
    }
    .imgone {
      height: 100%;
    }
  }
  .el-backtop {
    margin: 0.9rem auto 0.3rem;
    width: 3.48rem;
    height: 1.06rem;
    line-height: 1.06rem;
  }
}
</style>